import { Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MTBL_LOGO, CONTACT_EMAIL } from "../lib/content";

export default function Footer() {
  const { t } = useTranslation();
  const offices = t("data.offices", { returnObjects: true });

  return (
    <footer
      data-testid="site-footer"
      className="bg-paper border-t border-slate-200 mt-24"
    >
      <div className="container-mtbl py-20">
        <div className="grid gap-14 lg:grid-cols-12 items-start">
          <div className="lg:col-span-6 space-y-6">
            <img
              src={MTBL_LOGO}
              alt="MTBL Management Consultancy"
              className="h-24 md:h-28 lg:h-32 w-auto object-contain scale-[1.3] origin-left mix-blend-multiply"
            />
            <p className="text-slate-600 text-base max-w-md leading-relaxed">
              {t("footer.about")}
            </p>
            <p className="overline">{t("footer.positioning")}</p>
          </div>

          <div className="lg:col-span-6 space-y-8">
            <div>
              <p className="overline mb-5">{t("footer.offices")}</p>
              <div className="grid sm:grid-cols-2 gap-6">
                {offices.map((o) => (
                  <div
                    key={o.city}
                    data-testid={`footer-office-${o.city
                      .split(",")[0]
                      .toLowerCase()
                      .replace(/[^a-z]/g, "")}`}
                    className="flex gap-3 text-slate-600 text-sm leading-relaxed"
                  >
                    <MapPin size={16} className="shrink-0 mt-1 text-slate-400" />
                    <div>
                      <p className="text-[#0B1A3D] font-semibold">{o.city}</p>
                      {o.address && <p className="text-slate-600">{o.address}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <p className="overline mb-3">{t("footer.direct")}</p>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                data-testid="footer-email"
                className="inline-flex items-center gap-2 text-[#0B1A3D] hover:text-[#13275B] text-base font-semibold"
              >
                <Mail size={18} /> {CONTACT_EMAIL}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p
            className="text-xs text-slate-500 tracking-wide"
            data-testid="footer-copyright"
          >
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
          <p
            className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0B1A3D]"
            data-testid="footer-powered-by"
          >
            {t("footer.poweredBy")}
          </p>
          <p className="text-xs text-slate-500 max-w-2xl">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}
